<template>
  <div class="workOrderDetails">
    <loading v-if="loading"></loading>
    <div class="workOrderDetails__main">
      <div class="workOrderDetails__main__title">{{ details.status }}</div>
      <div class="workOrderDetails__main__practice">
        <div><Icon name="location-o" /></div>
        <div class="workOrderDetails__main__practice__size">
          {{ details.address }}
          <!-- <div class="workOrderDetails__main__practice__size__top">
            <div>{{ details.address }}</div>
            <div
              style="
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              "
            >
              {{ details.address }}
            </div>
          </div>
          <div
            style="
              color: #8f8f8f;
              margin-top: 6px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            "
          >
            广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村广东省深圳市福田区石厦西村
          </div> -->
        </div>
      </div>
      <div class="workOrderDetails__main__productList">
        <div class="workOrderDetails__main__productList__title">检测费用</div>
        <div class="workOrderDetails__main__productList__list">
          <div
            class="workOrderDetails__main__productList__list__item"
            v-for="(item, index) in details.list"
            :key="index"
          >
            <div class="workOrderDetails__main__productList__list__item__left">
              <div
                class="workOrderDetails__main__productList__list__item__left__img"
              >
                <img
                  style="width: 100%; height: 100%"
                  :src="GLOBAL.ssoServer + '/' + item.picture"
                  alt=""
                />
              </div>
              <div
                class="workOrderDetails__main__productList__list__item__left__information"
              >
                <div
                  class="workOrderDetails__main__productList__list__item__left__information__name"
                >
                  {{ item.name }}
                </div>
                <div
                  class="workOrderDetails__main__productList__list__item__left__information__num"
                >
                  x{{ item.number }}
                </div>
                <!-- <span
                  class="workOrderDetails__main__productList__list__item__left__information__jianxiu"
                >
                  检测并维修
                </span> -->
              </div>
            </div>
            <div
              class="workOrderDetails__main__productList__list__item__right"
              v-if="item.subtotal"
            >
              ¥{{ item.subtotal }}
            </div>
          </div>
        </div>
        <div class="workOrderDetails__main__productList__title">维修费用</div>
        <div
          class="workOrderDetails__main__productList__list"
          v-if="details.listMaintenance && details.listMaintenance.length > 0"
        >
          <Collapse v-model="activeNames">
            <!-- <div
            class="workOrderDetails__main__productList__list__item"
            v-for="(item, index) in details.listMaintenance"
            :key="index"
          >
          </div> -->
            <CollapseItem
              v-for="(item, index) in details.listMaintenance"
              :key="index"
              :name="index"
            >
              <template #title>
                <div class="CollapseItemTitle">
                  <div>{{ item.attachment }}</div>
                  <div>¥{{ item.subtotal }}</div>
                </div>
              </template>
              <div class="CollapseItem">
                <div>检测结果</div>
                <div class="CollapseItem__size">{{ item.result }}</div>
              </div>
            </CollapseItem>
          </Collapse>
        </div>
        <div class="workOrderDetails__main__productList__foot">
          <div>订单总额</div>
          <div class="workOrderDetails__main__productList__foot__total">
            ¥{{ details.total }}
          </div>
        </div>
      </div>
      <div class="workOrderDetails__main__information">
        <div class="workOrderDetails__main__information__item">
          <div class="workOrderDetails__main__information__item__name">
            工单名称
          </div>
          <div class="workOrderDetails__main__information__item__size">
            {{ details.name }}
          </div>
        </div>
        <div class="workOrderDetails__main__information__item">
          <div class="workOrderDetails__main__information__item__name">
            工单编号
          </div>
          <div class="workOrderDetails__main__information__item__size">
            {{ details.orderNo }}
          </div>
        </div>
        <div class="workOrderDetails__main__information__item">
          <div class="workOrderDetails__main__information__item__name">
            下单时间
          </div>
          <div class="workOrderDetails__main__information__item__size">
            {{ details.createdTimeStr }}
          </div>
        </div>
        <div
          style="display: flex; justify-content: flex-end; margin-bottom: 8px"
        >
          <div style="width: 90px"></div>
          <div
            style="
              width: calc(100% - 90px);
              height: 0.5px;
              border: 0.5px dashed #d9d9d9;
            "
          ></div>
        </div>
        <div
          class="workOrderDetails__main__information__item"
          style="margin-top: 20px"
        >
          <div class="workOrderDetails__main__information__item__name">
            故障描述
          </div>
          <div class="workOrderDetails__main__information__item__size">
            {{ details.description }}
          </div>
        </div>
        <div
          style="display: flex; justify-content: flex-end; margin-bottom: 8px"
        >
          <div style="width: 90px"></div>
          <div
            style="
              width: calc(100% - 90px);
              height: 0.5px;
              border: 0.5px dashed #d9d9d9;
            "
          ></div>
        </div>
        <div class="workOrderDetails__main__information__item">
          <div class="workOrderDetails__main__information__item__name">
            快递单号
          </div>
          <div class="workOrderDetails__main__information__item__size">
            <div style="display: flex; justify-content: space-between">
              <div>维修返厂单号</div>
              <div
                class="workOrderDetails__main__information__item__size__number"
              >
                {{ details.sendoffNumber }}
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 8px;
              "
            >
              <div>维修寄回单号</div>
              <div
                class="workOrderDetails__main__information__item__size__number"
              >
                {{ details.sendbackNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="workOrderDetails__main__noticediv"
        v-if="details.status === '待受理'"
      >
        <NoticeBar style="height: 35px" mode="closeable" :scrollable="false"
          >您已提交申请，技术人员会与您联系，请注意接听电话！</NoticeBar
        >
      </div>
    </div>
    <div class="workOrderDetails__foot">
      <div class="workOrderDetails__foot__but" @click="showSheet = true">
        联系售后服务人员
      </div>
      <div
        class="workOrderDetails__foot__but"
        v-if="details.status === '待邮寄'"
        @click="pushExpress"
      >
        填写单号
      </div>
      <div
        class="workOrderDetails__foot__but"
        v-if="details.status === '维修报价'"
        @click="verifyOrder"
      >
        确认报价
      </div>
      <div
        class="workOrderDetails__foot__but"
        v-if="details.status === '已发货'"
        @click="verifyReceive"
      >
        确认收货
      </div>
      <div
        class="workOrderDetails__foot__but"
        @click="verifyCancel"
        v-if="details.status === '待受理' || details.status === '待邮寄'"
      >
        取消订单
      </div>
    </div>
    <van-dialog
      v-model="dialogShow"
      :title="dialogSty.title"
      @confirm="dialogConfirm"
      show-cancel-button
      confirm-button-color="#82BF25"
    >
      <div style="margin: 10px 0 20px 16px; color: #888888; font-size: 12px">
        {{ dialogSty.content }}
      </div>
    </van-dialog>
    <ActionSheet
      v-model="showSheet"
      :actions="sheetList"
      @select="sheetConfirm"
      cancel-text="取消"
      close-on-click-action
    />
  </div>
</template>

<script>
import {
  Icon,
  Dialog,
  NoticeBar,
  Collapse,
  CollapseItem,
  ActionSheet,
} from "vant";
import {
  getDetail,
  cancel,
  confirmReceipt,
  confirmRepair,
} from "@/api/officialAccount/index.js";
import { initOpenid, initCodeApi } from "@/utils/getOpenid";
import Loading from "./loading.vue";

export default {
  components: {
    Icon,
    NoticeBar,
    Collapse,
    CollapseItem,
    Loading,
    ActionSheet,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      dialogShow: false,
      details: {},
      loading: true,
      dialogSty: {
        title: "",
        content: "",
        state: 1, // 1取消,2报价,3收货
      },
      activeNames: ["1"],
      showSheet: false,
      sheetList: [{ name: "0769-81504599" }],
    };
  },
  created() {
    console.log(this.$route.query);
    if (!localStorage.getItem("openId")) {
      initOpenid(this.getDetailHanlde);
    } else {
      this.$route.query.id && this.getDetailHanlde();
    }
    if (
      localStorage.getItem("openId") &&
      localStorage.getItem("openId") === "null"
    ) {
      initCodeApi();
    }
  },
  mounted() {},
  methods: {
    async getDetailHanlde() {
      const { data, code } = await getDetail({
        id: this.$route.query.id,
        openid: localStorage.getItem("openId"),
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.details = data;
      this.loading = false;
      console.log(data);
    },
    // 取消订单
    async cancelHanlde() {
      this.loading = true;
      const { code } = await cancel({
        id: this.$route.query.id,
        openid: localStorage.getItem("openId"),
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.getDetailHanlde();
    },
    // 确认报价
    async confirmRepairHanlde() {
      this.loading = true;
      const { code } = await confirmRepair({
        agree: 1,
        id: this.$route.query.id,
        openid: localStorage.getItem("openId"),
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.getDetailHanlde();
    },
    // 确认收货
    async confirmReceiptHanlde() {
      this.loading = true;
      const { code } = await confirmReceipt({
        id: this.$route.query.id,
        openid: localStorage.getItem("openId"),
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.getDetailHanlde();
    },
    // 取消订单弹窗
    verifyCancel() {
      this.dialogShow = true;
      this.dialogSty.state = 1;
      this.dialogSty.title = "取消工单";
      this.dialogSty.content = "您确定要取消该工单吗？";
    },
    // 确认报价
    verifyOrder() {
      this.dialogShow = true;
      this.dialogSty.state = 2;
      this.dialogSty.title = "是否同意该报价";
      this.dialogSty.content = "点击确定后即可与商务洽谈维修合同细则。";
    },
    // 确认收货
    verifyReceive() {
      this.dialogShow = true;
      this.dialogSty.state = 3;
      this.dialogSty.title = "是否确认收货";
      this.dialogSty.content = "收货前请仔细检查产品，确保没有损坏或缺陷。";
    },
    // 弹窗确认按钮
    dialogConfirm() {
      if (this.dialogSty.state === 1) {
        this.cancelHanlde();
      } else if (this.dialogSty.state === 2) {
        this.confirmRepairHanlde();
      } else if (this.dialogSty.state === 3) {
        this.confirmReceiptHanlde();
      }
    },
    // 拨打电话
    sheetConfirm() {
      window.location.href = "tel:076981504599";
    },
    pushExpress() {
      this.$router.push({
        path: "/expressDelivery",
        query: { id: this.$route.query.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-collapse-item__title--expanded::after {
  display: none;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
/deep/.van-cell::after {
  width: 100%;
  left: 0;
  border-bottom: 0.5px solid #d9d9d9;
}
/deep/.van-collapse-item--border::after {
  display: none;
}
/deep/.van-notice-bar__content {
  color: #d3b38c;
  font-size: 12px;
}
/deep/.van-collapse-item__content {
  padding: 0 0 16px 0;
}
/deep/.van-cell {
  padding: 12px 0;
}
/deep/.van-collapse-item {
  border-bottom: 0.5px solid #d9d9d9;
}
.CollapseItemTitle {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.CollapseItem {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  &__size {
    width: 170px;
    text-align: right;
  }
}
.workOrderDetails {
  &__main {
    overflow-y: auto;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    position: relative;
    padding-bottom: 12px;
    &__noticediv {
      position: fixed;
      left: 0;
      bottom: 60px;
      width: 100%;
    }
    &__tis {
      height: 35px;
      line-height: 35px;
      background: #fbf5db;
      font-size: 12px;
      padding: 0 12px;
      color: #d3b38c;
    }
    &__information {
      background-color: #fff;
      font-size: 12px;
      padding: 12px;
      margin-top: 8px;
      &__item {
        display: flex;
        min-height: 20px;
        align-items: center;
        margin: 8px 0;
        &__name {
          width: 60px;
          color: #979797;
          margin-right: 30px;
        }
        &__size {
          width: calc(100% - 88px);
          &__number {
            max-width: 50%;
            word-break: break-all;
          }
        }
      }
    }
    &__productList {
      background-color: #fff;
      padding: 0 12px;
      margin-top: 15px;
      &__foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 54px;
        font-size: 14px;
        &__total {
          word-break: break-all;
          max-width: 50%;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      &__list {
        &__item {
          // height: 84px;
          border-bottom: 0.5px solid #d9d9d9;
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          font-size: 14px;
          &__left {
            display: flex;
            &__img {
              width: 60px;
              height: 60px;
              margin-right: 12px;
            }
            &__information {
              display: flex;
              &__name {
                // margin-bottom: 24px;
                width: 100px;
              }
              &__jianxiu {
                font-size: 12px;
                text-align: center;
                padding: 2px 8px;
                background: #fa802b;
                border-radius: 2px;
                color: #fff;
              }
            }
          }
          &__right {
            max-width: 30%;
            word-break: break-all;
          }
        }
      }
      &__title {
        height: 48px;
        line-height: 48px;
        color: #26252a;
        border-bottom: 0.5px solid #d9d9d9;
      }
    }
    &__practice {
      background-color: #fff;
      display: flex;
      margin-top: 15px;
      padding: 0 12px;
      height: 74px;
      padding-top: 15px;
      overflow: hidden;
      color: #000;
      &__size {
        font-size: 12px;
        margin-left: 8px;
        height: 50px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        white-space: pre-line;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        &__top {
          display: flex;
        }
      }
    }
    &__state {
      background-color: #fff;
      display: flex;
      border-top: 0.5px solid #d9d9d9;
      padding: 0 12px;
      height: 74px;
      padding-top: 15px;
      color: #000;
      &__size {
        font-size: 12px;
        margin-left: 8px;
      }
    }
    &__time {
      font-size: 12px;
      // padding-left: 8px;
      background-color: #fff;
      padding: 0 12px;
    }
    &__title {
      height: 3rem;
      line-height: 3rem;
      font-size: 20px;
      font-weight: 900;
      background: #ffffff;
      padding-left: 12px;
    }
  }
  &__foot {
    height: 60px;
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 12px;
    padding: 12px;
    color: #676767;
    &__but {
      width: 89px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #efefef;
      border-radius: 40px;
      margin-left: 12px;
    }
  }
}
</style>
